module.exports = __webpack_public_path__ + "fontawesome-webfont.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/font-awesome-4.7.0/fonts/fontawesome-webfont.svg?v=4.7.0
// module id = 1110
// module chunks = 321